import React from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { CAMPAIGN_STEP_TITLES } from "../../utils/campaignPublishIssues";

export default function CampaignPublishBlockersDialog({
  open,
  onClose,
  issues = [],
  title = "Can't publish yet",
  onGoToStep,
}) {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth PaperProps={{ sx: { borderRadius: "16px" } }}>
      <DialogTitle
        sx={{
          pr: 6,
          fontWeight: 800,
          fontSize: "1.125rem",
          color: "#0f172a",
        }}
      >
        {title}
        <IconButton
          aria-label="Close"
          onClick={onClose}
          size="small"
          sx={{ position: "absolute", right: 10, top: 10, color: "#0f172a" }}
        >
          <CloseIcon fontSize="small" />
        </IconButton>
      </DialogTitle>
      <DialogContent sx={{ pt: 0, pb: 1, px: 3 }}>
        <Typography sx={{ fontSize: "15px", lineHeight: 1.45, color: "#334155", mb: 2 }}>
          Fix these items before you continue:
        </Typography>
        <ul style={{ margin: 0, paddingLeft: "1.25rem", color: "#0f172a" }}>
          {issues.map((issue, idx) => (
            <li key={`${issue.step}-${idx}`} style={{ marginBottom: 12 }}>
              <Typography component="span" sx={{ fontSize: "15px", color: "#334155" }}>
                {issue.message}
              </Typography>
              {onGoToStep && issue.step && issue.step !== "review" ? (
                <Button
                  type="button"
                  size="small"
                  onClick={() => {
                    onGoToStep(issue.step);
                    onClose();
                  }}
                  sx={{ mt: 0.5, display: "block", textTransform: "none", fontWeight: 700 }}
                >
                  Go to {CAMPAIGN_STEP_TITLES[issue.step] || issue.step}
                </Button>
              ) : null}
            </li>
          ))}
        </ul>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button onClick={onClose} sx={{ color: "#334155", fontWeight: 600 }}>
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
}
